import { BaseEntity } from "#sitis/internal/models/concrete/BaseEntity";
export class User extends BaseEntity {
  username;
  email;
  phone;
  formattedPhone;
  name;
  address;
  personalDiscount;
  legalType;
  legalTypeLabel;
  organizationName;
  inn;
  accountDetails;
  sex;
  sexLabel;
  birthday;
  activeBonuses;
  totalBonuses;
  avatarId;
  bonusCard;
  bonusPercent;
  isTwoFactorEnabled;
  group;
  externalData;
  settings;
  constructor(data) {
    super(data);
    this.username = data.username;
    this.email = data.email;
    this.phone = data.phone;
    this.formattedPhone = data.formatted_phone;
    this.name = data.name;
    this.address = data.address;
    this.personalDiscount = data.personal_discount;
    this.legalType = data.legal_type;
    this.legalTypeLabel = data.legal_type_label;
    this.organizationName = data.organization_name;
    this.inn = data.inn;
    this.accountDetails = data.account_details;
    this.sex = data.sex;
    this.sexLabel = data.set_label;
    this.birthday = data.birthday;
    this.activeBonuses = data.active_bonuses;
    this.totalBonuses = data.total_bonuses;
    this.avatarId = data.avatar_image_id;
    this.bonusCard = data.bonus_card;
    this.bonusPercent = data.bonus_percent;
    this.isTwoFactorEnabled = data.is_two_factor_enabled;
    this.group = data.group ? {
      id: data.group.id,
      name: data.group.name
    } : void 0;
    this.externalData = data.external_data;
    this.settings = data.settings;
  }
  toJSON() {
    return { ...this };
  }
}
